module.exports = __webpack_public_path__ + "static/GriegNightTrans.dca5c7e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/posts/img/GriegNightTrans.png
// module id = 1510
// module chunks = 168707334958949